import BaseError from './BaseError';
import { TriangleExclamationRegularGlyph } from '@acast-tech/decibel-glyphs';

const GenericError = ({ message }: { message: string }) => {
  return <BaseError icon={<TriangleExclamationRegularGlyph />} title="Error" desc={message} />;
};

export default GenericError;
